var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"call-btn",attrs:{"href":("tel:" + _vm.number)}},[_c('img',{attrs:{"src":require("@/assets/images/icons/phone.svg"),"alt":"blue-phone-icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }